export const primaryColors = [
  { className: "color-1" }, //red
  { className: "color-2" }, //orange
  { className: "color-3" }, //yellow
  { className: "color-4" }, //green
  { className: "color-5" }, //blue
  { className: "color-6" }, //purple
];

export const backgroundColors = [
  { className: "bg-color-1" }, //white
  { className: "bg-color-2" }, //black
];
